import { useMemo } from "react";
import useRenderField from "../useRenderField";
import getGridClassName from "../../utils/getGridClassName";
import styles from "./style.module.scss";

const useForm = (code, rows, { control, errors }) => {
    const renderField = useRenderField(control, errors);

    return useMemo(
        () => (
            <>
                {rows.map((row, rowIndex) => {
                    const gridClassName = getGridClassName(row);

                    return (
                        <div key={rowIndex}
                             className={`${styles.fieldsGrid} ${gridClassName}`}
                        >
                            {row.map(({
                                          name,
                                          label = "",
                                          placeholder = "",
                                          inputType = "text",
                                          valueMode = "label",
                                          labelField = "nameRu",
                                          required = false,
                                          disabled = false,
                                          inputCentered = false,
                                          onOptionSelect = null
                                      }, key) => renderField(code, {
                                    name,
                                    placeholder,
                                    inputType,
                                    label,
                                    valueMode,
                                    labelField,
                                    required,
                                    disabled,
                                    inputCentered,
                                    onOptionSelect
                                }, key)
                            )}
                        </div>
                    )
                })}
            </>
        ),
        [rows, renderField]
    );
}

export default useForm;